<div class="wrap">
    <div class="margin-large-bottom-res margin-large-top-res">
        <ul class="uk-flex-center" uk-tab>
            <li (click)="goToVirement()">
                <a href="/facturation/virements">
                    Encaissement
                </a>
            </li>
            <li (click)="goToControl()" *ngIf="session.role.ability === 'super-admin'">
                <a href="/facturation/controle">
                    Controle
                </a>
            </li>
            <li class="uk-active">
                <a>
                    Auto Facturation
                </a>
            </li>
        </ul>
    </div>

    <div uk-grid class="uk-grid-small remove-grid-ml-pl">

        <div class="uk-width-1-2 uk-width-1-4@s uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <select class="uk-select" [(ngModel)]="month" (ngModelChange)="onMonthChange($event)">
                    <option value="0">Tous</option>
                    <option value="1">Janvier</option>
                    <option value="2">Février</option>
                    <option value="3">Mars</option>
                    <option value="4">Avril</option>
                    <option value="5">Mai</option>
                    <option value="6">Juin</option>
                    <option value="7">Juillet</option>
                    <option value="8">Août</option>
                    <option value="9">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                </select>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <select class="uk-select" [(ngModel)]="selectYear" (ngModelChange)="onYearChange($event)">
                    <option *ngFor="let year of years; let i = index" value={{year}}>{{year}}</option>
                </select>
            </div>
        </div>

        <div class="uk-width-1-4@m uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <input class="search-bar" type="text" [(ngModel)]="search" placeholder="Rechercher"
                    (ngModelChange)="onSearchChange($event)" style="width: calc(100% - 20px);">
                <span class="uk-form-icon uk-form-icon-flip" style="right: 10px;">
                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="virements.length == 0 && loadingStatus === false" class="bold uk-margin-medium-top">
        Il n'y a pas d'auto facturation pour cette periode.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false">

        <div *ngIf="loadingStatus === false" class=" uk-margin-remove-top">
            <div *ngFor="let virement of virements; let i = index"
                class="uk-border-rounded uk-width-1-1 vop-background-white uk-margin-medium-top uk-padding-small">

                <div uk-grid class="uk-width-1-1">
                    <div class="uk-width-1-2 item-column bold" style="font-size: 17px;">
                        <div class="uk-display-block">
                            <span class="uk-text-small">Virement du <span class="uk-text-small"
                                    humanDateFormat="{{ virement.virementDate }}" noDay="true"
                                    shortened="true"></span></span>
                        </div>
                        <div class="uk-display-block">
                            <span class="uk-text-small uk-margin-small-left regular" style="margin: 0">Période du <span
                                    class="uk-text-small" humanDateFormat="{{ virement.dateDebut }}" noDay="true"
                                    shortened="true"></span> au <span class="uk-text-small"
                                    humanDateFormat="{{ virement.dateFin }}" noDay="true" shortened="true"></span>
                            </span>
                        </div>
                    </div>

                    <a class="uk-width-1-2 uk-text-center" href="/user/society/informations/{{ virement.adherentId }}">
                        <div class="uk-width-1-1 item-column bold uk-text-right uk-text-uppercase"
                            style=" font-size: 17px;">
                            {{ virement.adherent }}
                        </div>
                    </a>
                </div>

                <div class="uk-width-1-1 uk-margin-medium-top">
                    <div class="uk-width-1-2 item-column bold" *ngIf="virement.courses.length > 0"
                        style="font-size: 17px;">
                        Réservation
                    </div>
                    <div *ngFor="let reservation of virement.courses; let j = index"
                        style="border-bottom: 1px solid black;">
                        <div uk-grid class="uk-width-1-1 gain-list remove-grid-ml-pl pointer"
                            [routerLink]="['/reservation/informations', reservation.Id]">
                            <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                                <div class="uk-display-block">
                                    <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}"
                                        noDay="true" shortened="true"></span>
                                    <span class="uk-text-small uk-margin-small-left regular"
                                        hours="{{ reservation.ISODateStart }}"></span>
                                </div>
                                <div class="uk-display-block">
                                    <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}"
                                        noDay="true" shortened="true"></span>
                                    <span class="uk-text-small uk-margin-small-left regular"
                                        hours="{{ reservation.ISODateEnd }}"></span>
                                </div>
                                <div class="separator"></div>
                            </div>
                            <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center"
                                style="font-size: 17px;">
                                {{ reservation.Vehicle }}
                            </div>
                            <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase"
                                style="font-size: 13px;">
                                {{ reservation.User }}
                            </div>
                            <div *ngIf="session.role.ability === 'super-admin'"
                                class="uk-visible@s uk-width-1-6 item-column light uk-text-uppercase"
                                style="font-size: 13px;">
                                {{ reservation.CodeSociety }}
                            </div>
                            <div class="uk-visible@s uk-width-expand item-column"></div>

                            <div class="uk-visible@s uk-width-1-12 item-column">
                                <span class="bold">{{ reservation.kilometre }} km</span>
                            </div>

                            <div class="uk-visible@s uk-width-1-12 item-column">
                                <span class="bold">{{ reservation.prix }} €</span>
                            </div>

                            <div class="uk-visible@m uk-width-1-12 item-column" style="font-size: 15px;">
                                #{{ reservation.Code }}
                            </div>
                        </div>

                        <!-- <hr class="uk-divider-icon"> -->

                        <div uk-grid *ngFor="let commission of reservation.commissions; let i = index"
                            class="uk-width-1-1 remove-grid-ml-pl" style="margin-top: 0;">
                            <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                                <div class="uk-display-block uk-text-center uk-text-capitalize">
                                    {{ commission.nom }}
                                </div>
                                <!-- <div class="separator"></div> -->
                            </div>
                            <div class="uk-visible@s uk-width-2-3 item-column light uk-text-uppercase uk-text-left uk-margin-left"
                                style="font-size: 17px;">
                                {{ commission.description }}
                            </div>
                            <div class="uk-width-expand item-column"></div>

                            <div class="uk-width-1-12 item-column uk-text-left">
                                <span class="bold" style="word-break: initial;">{{ commission.prix }}€</span>
                            </div>

                            <div class="uk-width-expand item-column uk-invisible@s"></div>

                            <div class="hoverButton uk-width-1-12 item-column uk-text-left pointer"
                                (click)="removeCommission(reservation, commission)">
                                <img src="../../../../assets/icons/Close.svg" width="32px" height="32px" alt="user"
                                    class="uk-margin-left" />
                            </div>

                            <!-- <div class="uk-width-expand item-column uk-invisible@s"></div> -->
                        </div>

                        <div uk-grid class="uk-visible@s uk-width-1-1 remove-grid-ml-pl" style="margin-top: 0;">
                            <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                                <div class="uk-display-block uk-text-center">
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-text-center"
                                        type="text" [(ngModel)]="reservation.addCommissionNom" placeholder="Nom">
                                </div>
                                <div class="separator"></div>
                            </div>
                            <div class="uk-width-1-3 item-column light uk-text-uppercase uk-text-left uk-margin-left"
                                style="font-size: 17px;">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    placeholder="Description de la commission"
                                    [(ngModel)]="reservation.addCommissionDescription">
                            </div>
                            <div class=" uk-width-expand item-column"></div>

                            <div class=" uk-width-1-12 item-column uk-text-left">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="number"
                                    placeholder="100" [(ngModel)]="reservation.addCommissionPrix" min="0">
                            </div>

                            <div class="hoverButton uk-width-1-12 item-column pointer"
                                (click)="addCommission(reservation)">
                                <img src="../../../../assets/icons/Add.svg" width="32px" height="32px" alt="user"
                                    class="uk-margin-left" />
                            </div>
                        </div>
                        <!-- </div> -->

                    </div>
                </div>

                <!-- <div class="uk-margin-top" *ngIf="virement.commissions.length > 0">
                    <div class="uk-width-1-2 item-column bold" style="font-size: 17px;">
                        Frais
                    </div>
                    <div uk-grid *ngFor="let commission of virement.commissions; let j = index"
                        class="uk-width-1-1 reservation-list remove-grid-ml-pl">
                        <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                            <div class="uk-display-block uk-text-center uk-text-capitalize">
                                {{ commission.nom }}
                            </div>
                            <div class="separator"></div>
                        </div>
                        <div class="uk-visible@s uk-width-2-3 item-column light uk-text-uppercase uk-text-left uk-margin-left"
                            style="font-size: 17px;">
                            {{ commission.description }}
                        </div>
                        <div class="uk-width-expand item-column"></div>

                        <div class="uk-width-1-12 item-column uk-text-left">
                            <span class="bold" style="word-break: initial;">{{ commission.prix }}€</span>
                        </div>

                        <div class="uk-width-expand item-column uk-invisible@s"></div>

                        <div class="hoverButton uk-width-1-12 item-column uk-text-left pointer"
                            (click)="removeCommission(virement, commission)">
                            <img src="../../../../assets/icons/Close.svg" width="32px" height="32px" alt="user"
                                class="uk-margin-left" />
                        </div>

                        <div class="uk-width-expand item-column uk-invisible@s"></div>
                    </div>

                    <div uk-grid class="uk-visible@s uk-width-1-1 reservation-list remove-grid-ml-pl">
                        <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                            <div class="uk-display-block uk-text-center">
                   
                        <input class="input alt color-cold-grey bold uk-width-1-1 uk-text-center" type="text"
                            [(ngModel)]="virement.addCommissionNom" placeholder="Nom">
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-3 item-column light uk-text-uppercase uk-text-left uk-margin-left"
                    style="font-size: 17px;">
                    <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                        placeholder="Description de la commission" [(ngModel)]="virement.addCommissionDescription">
                </div>
                <div class=" uk-width-expand item-column"></div>

                <div class=" uk-width-1-12 item-column uk-text-left">
                    <input class="input alt color-cold-grey bold uk-width-1-1" type="number" placeholder="100"
                        [(ngModel)]="virement.addCommissionPrix" min="0">
                </div>

                <div class="hoverButton uk-width-1-12 item-column pointer" (click)="addCommission(virement)">
                    <img src="../../../../assets/icons/Add.svg" width="32px" height="32px" alt="user" class="uk-margin-left" />
                </div>
            </div>
        </div> -->


                <div class="uk-flex uk-flex-row@s uk-margin-small-top">
                    <div class="item-column bold" style="font-size: 17px;">
                        <div class="uk-display-block">
                            <span class="uk-text-small">Frais <span class="color-orange">VOP</span></span>
                        </div>
                        <div class="uk-display-block">
                            <span class="uk-text-small bold uk-margin-small-left regular"
                                style="margin: 0; font-size: 20px;">{{
                                virement.commissionPrix }} €</span>
                        </div>
                    </div>
                    <div class=" uk-width-expand item-column"></div>
                    <div class=" item-column bold" style="font-size: 17px;">
                        <div class="uk-display-block">
                            <span class="uk-text-small">Somme a facturé à <span class="color-orange">VOP</span></span>
                        </div>
                        <div class="uk-display-block">
                            <span class="uk-text-small bold uk-margin-small-left regular"
                                style="margin: 0; font-size: 20px;">{{
                                virement.reservationsPrix }} €</span>
                        </div>
                    </div>
                    <div class=" uk-width-expand item-column"></div>
                    <div>
                        <button *ngIf="i != 0" class="button bold " type="button">
                            <span>
                                <span class="vertical-align-middle uk-visible@s">FACTURE</span>
                                <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user"
                                    class="uk-small-margin-left@s" />
                            </span>
                        </button>

                        <button *ngIf="i == 0" class="button bold " type="button">
                            <span class="color-red">
                                <span class="vertical-align-middle uk-visible@s">Valider l'auto facturation</span>
                                <img src="../../../../assets/icons/Edit.svg" width="32px" height="32px" alt="user"
                                    class="uk-small-margin-left@s" />
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

            <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
                <div class="uk-position-center">
                    <button [disabled]="currentPage === 1" class="uk-button button"
                        (click)="prevPage()">Précédent</button>
                    <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                        <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                        <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue"
                            (click)="goPage(i + 1)">{{i + 1}}</div>
                    </div>
                    <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left"
                        (click)="nextPage()">Suivant</button>
                </div>
            </div> -->

        </div>
    </div>